import { render } from "./PagoParteSocial.vue?vue&type=template&id=5d70f5e6"
import script from "./PagoParteSocial.vue?vue&type=script&lang=js"
export * from "./PagoParteSocial.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__